module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FH54Yt/images/9781439655863.jpg?1688985072547",
      "alt": "This image is the cover for the book Texas Shipwrecks, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Texas Shipwrecks, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Texas coastline and offshore waters are flat, shallow, featureless, and filled with shoals. Texas waters are subjected to extreme weather, not just hurricanes and tropical storms but also northers and seasonal gales. This, combined with two centuries of naval warfare off Texas waters, produced many shipwrecks of all sorts, from Spanish treasure fleets to simple working boats. The ships of pirates, navies, cotton traders, immigrants, fishermen, and oil shippers line the Texas coast, cover the sea bottom off Texas, and blanket the bottom of Texas rivers. Each wreck has a story, romantic or repellent, prosaic or unusual, but all intriguing.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark Lardas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Mark Lardas is the author of numerous books on maritime and Texas history. A longtime resident of Texas, he has maintained an interest in the Texas maritime history, including shipwrecks. With generous assistance from and in cooperation with the Institute of Nautical Archeology at Texas A&M University, and numerous museums throughout the state of Texas, he has pulled together a fascinating collection of images to illustrate Texas's maritime history as seen from its shipwrecks from Cabeza de Vaca's first shipwreck in 1528 through the 21st century.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0